package com.milta.feature.route.domain.usecase

import com.milta.feature.delivery.domain.entity.AddressSuggestion
import com.milta.feature.route.domain.entity.LoadingAddress
import com.milta.feature.route.domain.repository.LoadingAddressRepository

/** POST /api/v1/loading-addresses (MIL-99) — only from a picked HERE suggestion, which carries the GPS. */
class AddLoadingAddressUseCase(private val repository: LoadingAddressRepository) {
    suspend operator fun invoke(suggestion: AddressSuggestion): Result<LoadingAddress> =
        repository.addLoadingAddress(suggestion.label, suggestion.latitude, suggestion.longitude)
}
